<template>
  <v-container fluid>
    <main-header-plat-a-pat />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="mx-auto">
      <v-table-derivations
        :headersTable="schema.headersTable"
        :recordDerivations="recordDerivations"
        :agreeDerivation="agreeDerivation"
      />
    </v-row>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatAPat from '@/components/includes/MainHeaderPlatAPat.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VTableDerivations from '@/components/base/VTableDerivations.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'PatRecordBPage',
  components: {
    MainHeaderPlatAPat,
    MainHeaderPlatB,
    VOverlayLoader,
    VTableDerivations,
    VSnackBar,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
    this.loadRecordDerivations();
  },
  computed: {
    ...mapGetters('patRecordBPage', ['schema', 'recordDerivations', 'status']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('patRecordBPage', ['loadSchema', 'loadRecordDerivations']),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEvents() {},
    async agreeDerivation(inputDerivation) {
      if (confirm('Desea aceptar esta solicitud')) {
        const id = inputDerivation.proPatId;

        this.$store.dispatch('patRecordBPage/saveDerivations', { id }).then(
          () => {
            this.reload();
            this.snackbarOpen();
          },
          () => {
            this.reload();
            this.snackbarOpen();
          }
        );
      }
    },
    reload() {
      this.loadSchema();
      this.loadRecordDerivations();
    },
    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
      }
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 90px;
}

.contentRowCentral {
  width: 80%;
  min-height: 400px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}
</style>
